import notify from 'devextreme/ui/notify';


const position = {
    direction: 'down-push',
    position: 'top right',
};
const notfiyDefault = {
    minWidth: 50,
    animation: {
        show: {
            type: 'fade',
            duration: 400,
            from: 0,
            to: 1,
        },
        hide: { type: 'fade', duration: 40, to: 0 },
        direction: 'down-push',
    },
    displayTime: 5500,
    closeOnSwipe: true,
};

export default function handleBackendResponse(response) {

    let message, type = 'success'; 

    if (response?.success && response?.data?.statusCode && response?.success !== 'Invalid Model') {
        type = 'success';
        if (response.data.messeges?.length > 0) {
            message = response.data.messeges.join(' ');
        } else {
            message = response.data.data;
        }
    } else if (Array.isArray(response?.data?.messeges)) {
        type = 'error'
        message = String(response.data.messeges);

    } else if (response?.errors) {
        type = 'error'
        message = String(response.errors);
    } else {
        type = 'error'
        message = 'An error has occurred. Please try again, and if the problem persists, contact the ATLAS software team.';
    }

    notify({
        message,
        type,
        ...notfiyDefault,
    }, position);

    return response?.success && response?.data?.statusCode && response?.success !== 'Invalid Model';
}